<div class="container-btn">
    <ion-img src="./../../../assets/icon/vitalia-cellphone.svg"></ion-img>
    <p class="title">¿Necesitas ayuda con este trámite?</p>
    <p class="message">Puedes guardarlo ahora y solicitar asistencia durante el horario de atención: Lun-Vie 8:45 a 17:30</p>
</div>